
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import BeerScreen from './beers'
import CokctailsScreen from './cokctails'
import BottleScreen from './bottle'
import MocktailScreen from './sigatureCocktails'
import CategoriesScreen from './categories';
import WinesScreen from './wines';
// import CoctailScreen from './coctail.js'
// import MargaritasScreen from './margaritas.js'
// import WinesScreen from './wines.js'
// import SpiritsScreen from './spirits.js'
// import BottlesScreen from './bottles.js'

function Index({setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

        const {change} = useRefresh();
    
     const [menus, setMenus] = useState([]);

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCoctatik, setshowCoctatik] = useState(false);
    const [showBeers, setshowBeers] = useState(false);
    const [Wines, setWines] = useState(false);
    
    const [showBottle, setshowBottle] = useState(false);
    const [showMocktail, setshowMocktail] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [beers, setbeers] = useState(false);
    const [coladas, setcoladas] = useState(false);
    const [martinis, setmartinis] = useState(false);
    const [sangria, setsangria] = useState(false);
    const [noalcol, setnoalcol] = useState(false);
    const [mocktail, setmocktail] = useState(false);
    const [datacoctail, setdatacoctail] = useState(false);

        
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
            if (item.id === 564) {
                setdatacoctail(item);
            }
            if (item.id === 393) {
                setbeers(item);
            }
            if (item.id === 390) {
                setcoladas(item);
            }
            if (item.id === 391) {
                setmartinis(item);
            }
            if (item.id === 392) {
                setsangria(item);
            }
            if (item.id === 566) {
                setnoalcol(item);
            }
                if (item.id === 594) {
                setmocktail(item);
            }
            });
      }, [menus]);
    
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px'}}>
                    
                    <h1 style={{color: 'white', textTransform: 'uppercase', fontSize: 40, fontWeight: "900", marginTop: 100}}>
                        drinks / bebidas
                    </h1>
                    
                    <div style={{display: 'flex', justifyContent: 'space-between', paddingInline: 30, flexDirection: 'column', alignItems: 'center'}}>
                        <div onClick={() => {
                           setshowCoctatik(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 5,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:30,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            COCKTAILS
                                        </p>
                                </div>
                        </div>

                        <div onClick={() => {
                            setshowBeers(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:10,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:30,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            beers
                                        </p>
                                </div>
                        </div>

                        <div onClick={() => {
                            setshowBottle(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:20,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:29,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            bottle services
                                        </p>
                                </div>
                        </div>
                        <div onClick={() => {
                            setdishs(noalcol)
                            setShowListProduct(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:20,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:29,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            non alcoholic
                                        </p>
                                </div>
                        </div>

                        <div onClick={() => {
                          setdishs(mocktail)
                            setShowListProduct(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:20,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:29,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            MOCKTAILS
                                        </p>
                                </div>
                        </div>

                        <div onClick={() => {
                          setWines(true)
                           
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:20,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:29,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            WINES
                                        </p>
                                </div>
                        </div>
                       
                    </div>
                                        
                    
                  
                </div>
                                        
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

                {showBeers && <BeerScreen setShowHappy={setshowBeers} />}
                 {Wines && <WinesScreen setShowHappy={setWines} />}
                {showCoctatik && <CokctailsScreen setShowHappy={setshowCoctatik} />}
                {showBottle && <BottleScreen setShowHappy={setshowBottle} />}
                {/* {showMocktail && <MocktailScreen setShowHappy={setshowMocktail} />} */}
                {/* 
                {showMargaritas && <MargaritasScreen setShowHappy={setshowMargaritas} />}
                {showWines && <WinesScreen setShowHappy={setshowWines} />}
                {showSpirits && <SpiritsScreen setShowHappy={setShowSpirits} />}
                {showBottles && <BottlesScreen setShowHappy={setshowBottles} />} */}
                

                 {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;